<template>
  <nuttrema-menu-list theme="sidebar-menu">

    <nuttrema-menu-list-item v-if="matched('participants-list')">

      <el-popover
        ref="popover-options"
        placement="right"
        width="200"
        trigger="hover">
        <nuttrema-menu-list theme="popover-nav">
          <nuttrema-menu-list-item>
            <p class="list-item-label">{{ $t('label.participants') }}</p>
          </nuttrema-menu-list-item>
          <section>

            <nuttrema-menu-list-item>
              <permissions-control-wrapper
                 action="label.add_new_participant"
                :clarification="true"
                :required-general="$PERMISSIONS_GENERAL.ADD"
                :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.PARTICIPANTS"
                :permissions="_get(PersonsList, 'meta.permissions')">
                <template slot="allowed">
                  <router-link
                     exact
                     tag="a"
                     activeClass="is-active"
                     class="list-item-link"
                    @click.native="closePopover"
                    :to="{ name: 'add-participant' }">
                      <span>{{ $t('label.add_new_participant') }}</span>
                    </router-link>
                  </router-link>
                </template>
                <template slot="not-allowed">
                  <a class="list-item-link is-lock">
                    <span>{{ $t('label.add_new_participant') }} <i class="far fa-lock-alt"></i></span>
                  </a>
                </template>
              </permissions-control-wrapper>
            </nuttrema-menu-list-item>

            <nuttrema-menu-list-item>
              <permissions-control-wrapper
                 action="label.invite_participant"
                :clarification="true"
                :required-general="$PERMISSIONS_GENERAL.INVITE_PARTICIPANT"
                :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.PARTICIPANTS"
                :permissions="_get(PersonsList, 'meta.permissions')">
                <template slot="allowed">
                  <router-link
                     exact
                     tag="a"
                     activeClass="is-active"
                     class="list-item-link"
                    @click.native="closePopover"
                    :to="{ name: 'participants-invite-participant' }">
                    <span>{{ $t('label.invite_participant') }}</span>
                  </router-link>
                </template>
                <template slot="not-allowed">
                  <a class="list-item-link is-lock">
                    <span>{{ $t('label.invite_participant') }} <i class="far fa-lock-alt"></i></span>
                  </a>
                </template>
              </permissions-control-wrapper>
            </nuttrema-menu-list-item>

          </section>
        </nuttrema-menu-list>

        <nuttrema-iconica-sidebar-link
          slot="reference"
          icon="far fa-plus" theme="add-button">
        </nuttrema-iconica-sidebar-link>
      </el-popover>
    </nuttrema-menu-list-item>
    <!-- end ~ participants-list -->

    <nuttrema-menu-list-item v-if="matched('participant-assigned-programs')">
      <permissions-control-wrapper
         action="label.assign_program"
        :clarification="true"
        :required-general="$PERMISSIONS_GENERAL.ADD_PROGRAM"
        :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.PROGRAM_DURATION"
        :permissions="_get(PersonPrograms, 'meta.permissions')">
        <template slot="allowed">
          <router-link
             tag="a" activeClass="is-active"
            :title="$t('label.assign_program')"
            :to="{ name: 'participant-search-programs' }">
            <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button"></nuttrema-iconica-sidebar-link>
          </router-link>
        </template>
        <template slot="not-allowed">
          <nuttrema-iconica-sidebar-link disabled icon="far fa-plus" theme="add-button"></nuttrema-iconica-sidebar-link>
        </template>
      </permissions-control-wrapper>
    </nuttrema-menu-list-item>

    <nuttrema-menu-list-item v-if="matched('participant-evolution-dashboard')">
      <router-link
         tag="a" activeClass="is-active"
        :title="$t('label.add_measurement')"
        :to="{ name: 'participant-evolution-add-measurement' }">
        <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button"></nuttrema-iconica-sidebar-link>
      </router-link>
    </nuttrema-menu-list-item>

  </nuttrema-menu-list>
</template>

<script>
import { find } from 'lodash';

import { PERSON_KEYS } from 'constants/types';

import NuttremaMenuList from 'components/ui/navigation/nuttrema-menu-list';
import NuttremaMenuListItem from 'components/ui/navigation/nuttrema-menu-list-item';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'cmpt-participant-section-add-new-options',
  props: {
    id: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaMenuList,
    NuttremaMenuListItem,
    NuttremaIconicaSidebarLink,
  },
  data() {
    return {
      type: PERSON_KEYS.participant,
    };
  },
  computed: {
    PersonsList() {
      return this.$store.getters.PersonsList(this.type);
    },
    PersonPrograms() {
      return this.$store.getters.PersonPrograms(this.id);
    },
  },
  methods: {
    closePopover() {
      this.$refs['popover-options'].doClose();
    },
    matched(name) {
      return find(this.$route.matched, { name });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/shared/blocks/cmpt-participant-section-add-new-options.vue